// extracted by mini-css-extract-plugin
export default {"datepicker":"sC9o0___DateRangeDropdown-module__datepicker"};